module.exports = __webpack_public_path__ + "media/images/icon__compete@2x-2d8f304b0af8d0bdfdfdd92bbdae0eed.png";